/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs */

const es_user_profile_api_keys_toasts_delete_loading_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando tu clave API…`)
};

const en_user_profile_api_keys_toasts_delete_loading_description = /** @type {(inputs: User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removing your API key…`)
};

/**
* | output |
* | --- |
* | "Removing your API key…" |
*
* @param {User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_toasts_delete_loading_description = /** @type {((inputs?: User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_Toasts_Delete_Loading_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_toasts_delete_loading_description(inputs)
	return en_user_profile_api_keys_toasts_delete_loading_description(inputs)
});
export { user_profile_api_keys_toasts_delete_loading_description as "user.profile.api_keys.toasts.delete.loading_description" }